var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22277",
    d: "M0.908698 1.5145C0.508783 0.847972 0.988896 0 1.76619 0H24.4338C24.7851 0 25.1106 0.184299 25.2913 0.485504L33.3826 13.971C33.7626 14.6044 33.7626 15.3956 33.3826 16.029L25.2913 29.5145C25.1106 29.8157 24.7851 30 24.4338 30H1.76619C0.988895 30 0.508783 29.152 0.908697 28.4855L8.3826 16.029C8.76262 15.3956 8.76262 14.6044 8.3826 13.971L0.908698 1.5145Z",
    fill: "#229D98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.cde2312f4347a8c12bae295474f2abf9.svg";
export { ForwardRef as ReactComponent };